import { createNodeId } from "../../behavior/types";

/** @param {string} kind */
export function createDefaultBtNode(kind) {
  const id = createNodeId();
  switch (kind) {
    case "sequence":
      return { id, kind: "sequence", children: [] };
    case "selector":
      return { id, kind: "selector", children: [] };
    case "retry":
      return { id, kind: "retry", maxAttempts: 3, child: null };
    case "repeat":
      return { id, kind: "repeat", count: 2, child: null };
    case "ifThenElse":
      return { id, kind: "ifThenElse", conditionChild: null, thenChild: null, elseChild: null };
    case "servoPickPlace":
      return {
        id,
        kind: "servoPickPlace",
        pickBodyUuid: "",
        dropBodyUuid: "",
        endEffectorRef: "gripper_target",
      };
    case "moveEeToXyz":
      return {
        id,
        kind: "moveEeToXyz",
        x: 0,
        y: 0.3,
        z: 0.2,
        targetBodyUuid: "",
        settleSeconds: 0.45,
        orientationMode: "free",
        orientationStrength: 0.8,
        endEffectorRef: "gripper_target",
      };
    case "moveEeByOffset":
      return {
        id,
        kind: "moveEeByOffset",
        dx: 0,
        dy: 0.05,
        dz: 0,
        settleSeconds: 0.35,
        orientationMode: "free",
        orientationStrength: 0.8,
        endEffectorRef: "gripper_target",
      };
    case "runTrainedModel":
      return {
        id,
        kind: "runTrainedModel",
        modelId: "go2-walk-stagef",
        durationSeconds: 3,
        commandVx: 0.2,
        commandWz: 0,
      };
    case "openGripper":
      return { id, kind: "openGripper", settleSeconds: 0.4 };
    case "closeGripper":
      return { id, kind: "closeGripper", settleSeconds: 0.4 };
    case "goToKeyframe":
      return { id, kind: "goToKeyframe", keyframeName: "Scene :: home" };
    case "wait":
      return { id, kind: "wait", seconds: 0.5 };
    case "randomizeObjectPose":
      return {
        id,
        kind: "randomizeObjectPose",
        bodyUuid: "",
        radiusXY: 0.12,
        yawRangeDeg: 45,
      };
    case "setObjectPose":
      return {
        id,
        kind: "setObjectPose",
        bodyUuid: "",
        x: 0,
        y: 0.05,
        z: 0,
        qw: 1,
        qx: 0,
        qy: 0,
        qz: 0,
      };
    case "resetToBaseline":
      return { id, kind: "resetToBaseline" };
    case "markSuccess":
      return { id, kind: "markSuccess" };
    case "markFailure":
      return { id, kind: "markFailure" };
    case "conditionObjectGrasped":
      return { id, kind: "conditionObjectGrasped", bodyUuid: "", minHeightY: 0.04 };
    case "conditionEeNear":
      return {
        id,
        kind: "conditionEeNear",
        endEffectorRef: "gripper_target",
        x: 0,
        y: 0.3,
        z: 0,
        targetBodyUuid: "",
        toleranceM: 0.05,
      };
    case "conditionObjectNear":
      return {
        id,
        kind: "conditionObjectNear",
        bodyUuid: "",
        x: 0,
        y: 0.05,
        z: 0,
        targetBodyUuid: "",
        toleranceM: 0.08,
      };
    case "conditionTimeElapsed":
      return { id, kind: "conditionTimeElapsed", seconds: 1 };
    default:
      return { id, kind: "wait", seconds: 0.1 };
  }
}
